import { Row, Col } from 'antd'
import { useTranslation } from 'next-i18next'
import { webAssets } from '../../../utils/webAssets'
import ResponsiveImage from '../ResponsiveImage'

import Diamond from '../../svgs/aboutUs/Diamond'

const paragraphs = [
  "Il nostro obiettivo è trasformare l'assistenza fiscale rendendola più accessibile, conveniente e efficiente attraverso l'utilizzo delle moderne tecnologie digitali.",
  "Vogliamo diventare il punto di riferimento nel settore dell'assistenza fiscale in Italia, offrendo servizi di alta qualità e un'esperienza cliente eccezionale. I nostri valori sono:",
]

const OurValues = () => {
  const { t } = useTranslation('common')
  return (
    <div className='technology pt-28 lg:pt-60 pb-20 lg:pb-40'>
      <div className='container mx-auto'>
        <Row justify='end' align='middle' gutter={[60, 24]}>
          <Col
            xs={{ order: 1, span: 24 }}
            md={{ order: 1, span: 12 }}
            lg={{ order: 1, span: 9 }}
          >
            <ResponsiveImage
              alt='I nostri valori SmartCaf'
              src={webAssets.aboutUs2}
              width={456}
              height={272}
            />
          </Col>
          <Col
            xs={{ order: 2, span: 24 }}
            md={{ order: 2, span: 12 }}
            lg={{ order: 2, span: 14 }}
          >
            <div className='flex items-center gap-8 mb-28'>
              <Diamond style='w-32' />
              <h2 className='text-[1.75rem] text-green font-semibold mb-0'>
                I NOSTRI VALORI
              </h2>
            </div>
            {paragraphs.map((paragraph, index) => (
              <p
                key={index}
                className='text-dimmed font-light text-xl leading-10 mb-24 last:mb-0'
              >
                {t(paragraph)}
              </p>
            ))}
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default OurValues
